/* eslint-disable no-alert */
import React from 'react'
import { Button, Header, Form, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'

import CommissionField from '../fields/feeRateField'

export default class DriverForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    feeRate: 0,
    publishing: false,
  }

  onPublish = e => {
    const { publishing } = this.state
    e.preventDefault()

    if (publishing) return

    const confirmed = window.confirm('Are you sure to make this action?')

    if (confirmed) {
      this.publish()
    }
  }

  publish = async () => {
    const { feeRate } = this.state
    const { onClose, segmentId } = this.props
    const updates = {}

    try {
      this.setState({ publishing: true })

      let ref = firebase.database().ref('deliverers')

      if (segmentId)
        ref = ref.orderByChild('driver_segment').equalTo(segmentId)

      const snapshot = await ref.once('value')

      snapshot.forEach(data => {
        updates[`deliverers/${data.key}/delivery_fee_rate`] = Number(feeRate)
      })

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ publishing: false }, () => {
        onClose()
        alert('Drivers Delivery Fee Rate Published.')
      })
    } catch (error) {
      this.setState({ publishing: false })
      alert(error.message || error)
    }
  }

  render() {
    const { feeRate, publishing } = this.state
    const { visible, onClose } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content="Drivers Delivery Fee Rate" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onPublish}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={publishing}
          >
            <Form.Group widths="equal">
              <CommissionField
                onChange={(field, value) => this.setState({ feeRate: value })}
                value={feeRate}
              />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={publishing}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={publishing}
            disabled={publishing}
          >
            Publish
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/forms/feeRateForm.js